export default __webpack_public_path__ + "static/media/arrow-back.54f9fef1.svg";